import api from './base-api';

export interface SlatesByEventQueryArgs {
	eventId: string;
	lobbyId?: string;
}

const gamesApi = api.injectEndpoints({
	endpoints: (builder) => ({
		// PUBLIC
		getSlatesByEventId: builder.query<any[], SlatesByEventQueryArgs>({
			query: ({ eventId, lobbyId }) => ({
				url: `slates/event`,
				params: { eventId, ...(lobbyId && { lobbyId }) },
			}),
			providesTags: (result) =>
				result
					? [
							...result.map(({ id }: any) => ({ type: 'Slate' as const, id })),
							{ type: 'Slate' as const, id: 'LIST' },
						]
					: [{ type: 'Slate' as const, id: 'LIST' }],
			extraOptions: { skipAuth: true },
		}),
		getAllEventsCategories: builder.query({
			query: () => ({
				url: 'events/categories',
			}),
			providesTags: ['Categories'],
			extraOptions: {
				skipAuth: true,
			},
		}),
		getMatchById: builder.query({
			query: (id: any) => ({
				url: `matches/${id}`,
			}),
			extraOptions: { skipAuth: true },
		}),
		// ADMIN
		getEventForAdmin: builder.query<any, string>({
			query: (id) => ({
				url: `events/${id}/admin`,
				method: 'GET',
			}),
		}),
	}),
});

export const {
	useGetSlatesByEventIdQuery,
	useGetAllEventsCategoriesQuery,
	useGetMatchByIdQuery,
	useGetEventForAdminQuery,
	useLazyGetEventForAdminQuery,
} = gamesApi;

export default gamesApi;
